import { myFetch, HttpMethod } from './baseService';

export interface ApiEnvelope<T> {
  code: string | number;
  message: string;
  object_: T;
}

export interface Residente {
  res_email?: string;
  res_nombre_completo?: string;
  res_torre?: string;
  res_torre_nombre?: string;
  res_apartamento?: string;
  res_apartamento_nombre?: string;
  res_tipo_usuario?: string;
  res_tipo_usuario_nombre?: string;
  res_tipo_documento?: string;
  res_tipo_documento_nombre?: string;
  res_numero_documento?: string;
  res_numero_celular?: string;
  res_estatus?: string;
  res_estatus_nombre?: string;
  res_ruta_foto?: string;
  res_codigo?: string;
  res_nombre?: string;
  res_celular?: string;
  res_foto?: string;
  [key: string]: any;
}

export interface ObtenerResidentesRequest {
  "correo electronico usuario": string;
  "unidad residencial codigo": string;
  "torre codigo": string;
  "apartamento codigo": string;
  "tipo usuario codigo": string;
}

export interface ObtenerResidenteDetalleRequest {
  "correo electronico usuario": string;
  "unidad residencial codigo": string;
  "torre codigo": string;
  "apartamento codigo": string;
  "tipo usuario codigo": string;
}

export interface IngresarResidenteALibroVisitasRequest {
  unidad_residencial: string;
  "torre nombre": string;
  "apartamento nombre": string;
  nombre: string;
  tipo_documento_codigo?: string;
  numero_documento?: string;
  celular?: string;
  "foto nombre"?: string;
}

export const obtenerResidentes = async (payload: ObtenerResidentesRequest) => {
  const requestPayload = {
    "correo electronico usuario": String(payload["correo electronico usuario"] || ""),
    "unidad residencial codigo": String(payload["unidad residencial codigo"] || ""),
    "torre codigo": String(payload["torre codigo"] || ""),
    "apartamento codigo": String(payload["apartamento codigo"] || ""),
    "tipo usuario codigo": String(payload["tipo usuario codigo"] || ""),
  };
  
  const envelope = await myFetch<ApiEnvelope<Residente[]>>(
    'residente/Obtener_todos',
    HttpMethod.POST,
    requestPayload
  );
  return envelope;
};

export const obtenerResidenteDetalle = async (payload: ObtenerResidenteDetalleRequest) => {
  const requestPayload = {
    "correo electronico usuario": String(payload["correo electronico usuario"] || ""),
    "unidad residencial codigo": String(payload["unidad residencial codigo"] || ""),
    "torre codigo": String(payload["torre codigo"] || ""),
    "apartamento codigo": String(payload["apartamento codigo"] || ""),
    "tipo usuario codigo": String(payload["tipo usuario codigo"] || ""),
  };
  
  const envelope = await myFetch<ApiEnvelope<Residente[]>>(
    'residente/Obtener_todos',
    HttpMethod.POST,
    requestPayload
  );
  return envelope;
};

export const ingresarResidenteALibroVisitas = async (payload: IngresarResidenteALibroVisitasRequest) => {
  const envelope = await myFetch<ApiEnvelope<any>>(
    'residente/Ingresa_a_libro_visitas',
    HttpMethod.POST,
    payload
  );
  return envelope;
};

